module.exports = __webpack_public_path__ + "055a2f4e2d2427ae3ce84819a421ca10.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/coloring/nl3.pdf
// module id = 933
// module chunks = 3